import { render, staticRenderFns } from "./company-info-invoice.vue?vue&type=template&id=0651f41e&scoped=true&"
import script from "./company-info-invoice.vue?vue&type=script&lang=js&"
export * from "./company-info-invoice.vue?vue&type=script&lang=js&"
import style0 from "./company-info-invoice.vue?vue&type=style&index=0&id=0651f41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0651f41e",
  null
  
)

export default component.exports